import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, Button, Checkbox, Row, Col, notification, Spin, Image,Popconfirm, DatePicker, Tooltip, InputNumber } from 'antd';
import { FileImageOutlined, AudioOutlined,DeleteOutlined, VideoCameraOutlined, CloseOutlined } from '@ant-design/icons';
import StudentLoader from '../common/student-loader';
import BatchLoader from '../common/batch-loader';
import GroupLoader from '../common/group-loader';
import StreamLoader from '../common/stream-loader';
import ClassDivisionLoader from '../common/class-division-loader';
import ResourceLevel from '../common/resource-level-loader';
import { projectStacks,global_var } from '../../services/cs-lab-config';
import { fileUpload, updateResources, servUploadFileToCloud } from '../../services/ide-apis';
import { getIdeProjectTypeMetaData,trackEvent } from '../utils/util-functions';
import TinyMCEEditor from '../common/tinymce-editor-loader';
import dayjs from 'dayjs';
import { ReactComponent as PlusIcon } from '../../assets/logos/plusIcon.svg';

const EditAssignment = ({ open, onCancel, onCreate, loading, hideClassFilter, editRecord }) => {
    const [form] = Form.useForm();
    const { Option } = Select;
    const [assignTo, setAssignTo] = useState("");
    const [moreOptionChecked, setMoreOptionChecked] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState(null);
    const [selectedBatch, setSelectedBatch] = useState([]);
    const [selectedClassDivision, setSelectedClassDivision] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState([]);
    const [image, setImage] = useState([]);
    const [audio, setAudio] = useState([]);
    const [imagePreview, setImagePreview] = useState([]);
    const [audioPreview, setAudioPreview] = useState(null);
    const [buttonText, setButtonText] = useState("Update");
    const [buttonLoader, setButtonLoader] = useState(false);
    const [imageLoading, setImageLoading] = useState(false);
    const [audioLoading, setAudioLoading] = useState(false);
    const [questionDescription, setQuestionDescription] = useState(null);
    const [intialQuestionDescription, setInitalQuestionDescription] = useState(null);
    const [video, setVideo] = useState([]);
    const [videoPreview, setVideoPreview] = useState([]);
    const [videoLoading, setVideoLoading] = useState(false);
    const [dueDateChecked, setDueDateChecked] = useState(false);
    const [selectedDueDate, setSelectedDueDate] = useState("");
    const [dueDateInitialValue, setDueDateInitialValue] = useState('');
    const [isClassChanged, setIsClassChanged] = useState(false);
    const [isIndividualChanged, setIsIndividualChanged] = useState(false);
    const [isBatchChanged, setIsBatchChanged] = useState(false);
    const [isGroupChanged, setIsGroupChanged] = useState(false);
    const [singleClassDivision, setSingleClassDivision] = useState([]);

    useEffect(() =>{
        if(editRecord && editRecord.dueDate){
            const dueDate = dayjs(new Date(editRecord.dueDate))
            setDueDateInitialValue(dueDate)
            setDueDateChecked(true)
        }
    },[editRecord])

    const handleCancel = () => {
        setDueDateInitialValue(null);
        onCancel();
    }
    const disabledDate = (current) => {
        // Disable dates before today
        const today = dayjs().startOf('day');
        return current && dayjs(current).isBefore(today, 'day');
    };

    const handleMoreOptionChange = (e) => {
        setMoreOptionChecked(e.target.checked);
    };

    const handleStreamChange = (value) => {
        setSingleClassDivision(prevState => ({
            ...prevState,
            ...value
          }));
    };

    const addClassDivision = () => {
        if (singleClassDivision.fkClassId && singleClassDivision.fkDivisionId) {
            if (!selectedClassDivision.some(
                item => item.fkClassId === singleClassDivision.fkClassId && item.fkDivisionId === singleClassDivision.fkDivisionId &&
                item.streamId === singleClassDivision.streamId
              )) {
                // Add the singleClassDivision to selectedClassDivisions
                setSelectedClassDivision(prevClassDivisions => [...prevClassDivisions, singleClassDivision]);
              }
        }
    }

    const removeClassDivision = (index) => {
        setIsClassChanged(true);
        setSelectedClassDivision(prevClassDivisions => 
          prevClassDivisions.filter((_, i) => i !== index)
        );
    };

    const handleFileChange = async (e, type) => {
        try {
            // Set loading to true when starting the file upload
            const files = e.target.files;

            if (type === 'video'){
                setVideoLoading(true)
                const videoMaxFileSize = 400;
                for (const selectedVideoObj of Array.from(files)) {
                    const fileSize = Math.ceil((selectedVideoObj.size / (1000 * 1000)));
                    if (fileSize < videoMaxFileSize) {
                        if (!selectedVideoObj.videoLink) {
                            try {
                                const uploadedResponse = await servUploadFileToCloud(selectedVideoObj);
                               
                                if (uploadedResponse.status === 'uploaded') {
                                    let uploadObjVideo = {
                                        "type": "video",
                                        "question": uploadedResponse.fileKey
                                    };
                                    let newVideo = {
                                        file: selectedVideoObj,
                                        preview: URL.createObjectURL(selectedVideoObj)
                                    };
                                
                                    setVideo(prevVideos => [...prevVideos, uploadObjVideo]);
                                    setVideoPreview(prevVideos => [...prevVideos, newVideo]);
                                } else {
                                    console.error('Unexpected upload status:', uploadedResponse.status);
                                }
                            } catch (error) {
                                console.error('Error during file upload process', error);
                            }
                        }
                    }
                }
                setVideoLoading(false)
            
            }else{

                let fileRequest = {};
                const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB
                const fileArray = Array.from(files);

                for (const file of fileArray) {
                    if (file.size > maxSizeInBytes) {
                        notification.error({
                            message: 'Error',
                            description: `File size exceeds the allowed limit (5 MB): ${file.name}. Please choose a file with a smaller size.`,
                        });
                        return;
                    }
                }

                // Handle multiple files
                for (const file of fileArray) {
                    if (type === 'image') {
                        setImageLoading(true);
                        fileRequest = {
                            "pathToBeSave": "labQuestionImages"
                        }
                    }
                    if (type === 'audio') {
                        setAudioLoading(true);
                        fileRequest = {
                            "pathToBeSave": "labQuestionAudio"
                        }
                    }
                    // if (type === 'video') {
                    //     setVideoLoading(true);
                    //     fileRequest = {
                    //         "pathToBeSave": "labQuestionVideo"
                    //     }
                    // }

                    const response = await fileUpload(file, fileRequest);

                    // Check if the file size exceeds the limit (in bytes)
                    if (response.status === 200 && response.data !== "") {
                        // Create a new image or audio object
                        if (type === "image") {
                            let uploadObjImage = {
                                "type": "image",
                                "question": 'labQuestionImages/' + response.data
                            };
                            let newImage = {
                                file: file,
                                preview: URL.createObjectURL(file)
                            };

                            setImage(prevImages => [...prevImages, uploadObjImage]);
                            setImagePreview(prevPreviews => [...prevPreviews, newImage]);
                            // setImage(prevImages => [...prevImages, uploadObjImage]);
                            // setImagePreview(URL.createObjectURL(file));
                        }
                        if (type === "audio") {
                            let uploadObjAudio = {
                                "type": "audio",
                                "question": 'labQuestionAudio/' + response.data
                            };
                            let newAudio = {
                                file: file,
                                preview: URL.createObjectURL(file)
                            };  
                            setAudio(prevAudios => [...prevAudios, uploadObjAudio]);
                            setAudioPreview(prevAudios => [...prevAudios, newAudio]);
                        }
                    } else {
                        console.error("Service request failed:", response.statusText);
                    }
                }
            }
        } catch (error) {
            console.error("Error during service request:", error);
        } finally {
            setImageLoading(false);
            setAudioLoading(false);
            setVideoLoading(false);
        }
    };

    const handleResourceLevelChange = (value) => {
        setSelectedLevel(value.data);
    };
    const handleStudentChange = (value) => {
        setIsIndividualChanged(true);
        setSelectedStudent(value);
    };
    const handleEditorChange = (content) => {
        setQuestionDescription(content);
    };

    const handleBatchChange = (value) => {
        setIsBatchChanged(true);
        setSelectedBatch(value);
    };

    const handleClassDivision = (value) => {
        setIsClassChanged(true);
        setSingleClassDivision(value);
    };

    const handleGroupChange = (value) => {
        setIsGroupChanged(true);
        setSelectedGroup(value);
    };

    const handleDatePickerChange = (value, dateString) => {
        setSelectedDueDate(dateString);
    };

    const handleDueDateChange = (e) => {
        setDueDateChecked(e.target.checked);
        
    };

    const onFinish = async (values) => {
        trackEvent("edit_lab_assignment_question_button_clicked",{});
        setButtonText("Updating Lab Question...");
        setButtonLoader(true);
        if (
            (!selectedBatch || selectedBatch.length === 0) &&
            (!selectedStudent || selectedStudent.length === 0) &&
            (!selectedClassDivision || selectedClassDivision.length === 0) &&
            (!selectedGroup || selectedGroup.length === 0)
        ) {
            // Handle the case where none of the assignment methods are selected
            notification.error({
                message: 'Error',
                description: 'Choose atleast one class division/student/batch/group to assign.',
            });
            setButtonLoader(false);
            setButtonText("Assign");
            return
            // You can also show a notification or alert to the user
        }
        let elements = [];
        let questionArray = [];
        let studentMappings = [];

        const resourceObj = {
            "companyId": global_var.company_id,
            "fkUserLoginId": global_var.user_login_id,
            "Name": "Lab question",
            "projectType": values.projectType,
            "title": values.questionTitle,
            "subjectId": "5903134e6e5694e0619fc82d",  // Directly set to subject CS lab
            "subjectName": "Computer Science",
            "teacherName": global_var.user_name,
            "totalMark": values.maximumMark,
        }
        if (selectedDueDate) {
            resourceObj.dueDate = selectedDueDate;
            setDueDateChecked(true);

        }
        if (selectedLevel?._id) {
            resourceObj.resourceStudentLevelName = selectedLevel.resourceStudentLevelName;
            resourceObj.resourceStudentLevelColor = selectedLevel.resourceStudentLevelColor;
            resourceObj.fkResourceStudentLevelId = selectedLevel._id;
        }
        if (values.projectType === 'python') {
            resourceObj.subSubjectName = "Python";
            resourceObj.subSubjectId = "5c0ef9129b0452781408b30f";
        }
        if (values.projectType === 'html_css') {
            resourceObj.subSubjectName = "HTML";
            resourceObj.subSubjectId = "5c0efaa29b0452781008b30b";
        }
        if (values.projectType === 'vc3') {
            resourceObj.subSubjectName = "Visual Coding";
            resourceObj.subSubjectId = "65953a8aee6426264537307c";
        }
        if (values.projectType === 'sql2') {
            resourceObj.subSubjectName = "SQL";
            resourceObj.subSubjectId = "65953a2aee6426264537307b";
        }
        questionArray.push({
            "type": "text",
            "question": questionDescription
        })
        if (image.length > 0) {
            questionArray.push(...image);
        }
        if (audio.length > 0) {
            questionArray.push(...audio);
        }
        if (video.length > 0) {
            questionArray.push(...video);
        }

        elements.push({
            "displayName": "Title",
            "type": "cours-element-title",
            "value": values.questionTitle

        })
        elements.push({
            "displayName": "Lab question",
            "value": {
                "mark": {
                    "totalMark": values.maximumMark
                },
                "type": "descriptive",
                "question": questionArray,
                "ques": questionDescription
            }

        })
        resourceObj.elements = elements;
        values.elements = elements;
        // Trigger the parent component's onCreate function

        if (selectedBatch && selectedBatch.length > 0 && isBatchChanged) {
            studentMappings = [{
                "type": "batches",
                "batches": selectedBatch
            }];
        }

        if (selectedGroup && selectedGroup.length > 0 && isGroupChanged) {
            studentMappings = [{
                "type": "groups",
                "groups": selectedGroup
            }];
        }

        if (selectedStudent && selectedStudent.length > 0 && isIndividualChanged) {
            studentMappings = [{
                "type": "individual-students",
                "individualStudents": selectedStudent
            }];
        }

        if (selectedClassDivision && selectedClassDivision.length > 0 && isClassChanged) {
    
            const studentMappingItem = selectedClassDivision.map(item => ({
                type: "class-division",
                classId: item.fkClassId,
                className: item.fkClassName,
                ...(item.fkDivisionId && item.fkDivisionName ? {
                  divisionId: item.fkDivisionId,
                  divisionName: item.fkDivisionName
                } : {}),
                ...(item.streamId && item.classStreamName ? {
                    streamId: item.streamId,
                    streamName: item.classStreamName
                } : {})
              }));
              studentMappings = studentMappingItem;
        }

        let requestObj = {
            resourceData: resourceObj,
            rmId: global_var.roleMappingId,
            resourceMappingId: editRecord.labQuestionsMappingId,
            resourceId: editRecord._id,
        }

        if (studentMappings && studentMappings.length > 0) {
            requestObj.studentMappings = studentMappings;
          }

        if (selectedGroup && selectedGroup.length > 0) {
            requestObj.groups = selectedGroup;
        }
        const response = await updateResources(requestObj);
        setButtonLoader(false);
        setButtonText("Update");
        if (response.data.statusCode === 200) {
            notification.success({
                message: 'Success',
                description: "Successfully updated lab question",
            });
            values._id = editRecord._id;
            if(response.data.totalAssignedCount){
                values.totalAssignedCount = response.data.totalAssignedCount;
            }
            if (selectedStudent && selectedStudent.length > 0) {
                values.assignTo = [
                    {
                        "type": "individual-students",
                        "individualStudents": selectedStudent
                    }
                ]
            }
            if (selectedBatch && selectedBatch.length > 0) {
                values.assignTo = [
                    {
                        "type": "batches",
                        "batches": selectedBatch
                    }
                ]
            }
            if (selectedGroup && selectedGroup.length > 0) {
                values.assignTo = [
                    {
                        "type": "groups",
                        "groups": selectedGroup
                    }
                ]
            }
            if (selectedClassDivision && selectedClassDivision.length > 0) {
                values.assignTo = selectedClassDivision.map((item) => {
                    const classDivisionObj = {
                        type: "class-division",
                        classId: item.fkClassId,
                        className: item.fkClassName,
                    };
            
                    if (item.fkDivisionId) {
                        classDivisionObj.divisionId = item.fkDivisionId;
                        classDivisionObj.divisionName = item.fkDivisionName;
                    }

                    if (item.streamId) {
                        classDivisionObj.streamId = item.streamId;
                        classDivisionObj.streamName = item.streamName;
                    }
            
                    return classDivisionObj;
                });
            }

            onCreate(values, 'edit');
            setDueDateInitialValue(selectedDueDate)
            handleCancel();
            setIsClassChanged(false)
            setIsIndividualChanged(false)
            setIsBatchChanged(false)
            setIsGroupChanged(false)

        } else {
            notification.error({
                message: 'Error',
                description: response.data.message,
            });
        }
    }

    const renderAssignToSection = () => {
        switch (assignTo) {
            case 'ClassDivisions':
                return (
                    <>
                        <ClassDivisionLoader onChange={handleClassDivision} classDivision={selectedClassDivision ? selectedClassDivision : null} />
                        <StreamLoader  onChange={handleStreamChange}  classDivision={singleClassDivision ? singleClassDivision : null}/>
                        <Col span={8}>
                            <div style={{ display: 'inline-flex', cursor: 'pointer' }} onClick={addClassDivision}>
                                <PlusIcon style={{marginLeft: '10px', fontWeight: 'large', cursor: 'pointer' }} />
                                <span style={{ marginLeft: '5px', color:'#6a737b' }}>Add</span>
                            </div>
                        </Col>
                        <Col span={24} className="mt-2">
                            <Row>
                                {selectedClassDivision.map((cd, index) => (
                                    <div key={index} style={{ backgroundColor: '#1777ff', display: 'flex', alignItems: 'center', marginBottom: '8px', borderRadius:'5px', paddingRight: '5px', paddingLeft: '5px', fontSize:'x-small', color:'white', width:'max-content', marginRight: '5px' }}>
                                        <span style={{ marginRight: '8px' }}>  {`${cd.fkClassName}${cd.fkDivisionName ? `-${cd.fkDivisionName}` : ''}${cd.classStreamName ? ` - ${cd.classStreamName}` : ''}`}</span>
                                        <CloseOutlined onClick={() => removeClassDivision(index)} style={{ cursor: 'pointer' ,fontSize:'x-small'}} />
                                    </div>
                                ))}
                            </Row>
                        </Col>
                    </>
                );
            case 'Batches':
                return <BatchLoader onChange={handleBatchChange} selectedBatch={selectedBatch ? selectedBatch : null} />;
            case 'IndividualStudents':
                return <StudentLoader onChange={handleStudentChange} students={selectedStudent ? selectedStudent : null} />;
            case 'Groups':
                return <GroupLoader onChange={handleGroupChange} selectedGroup={selectedGroup ? selectedGroup : null} />;    
            default:
                return null;
        }
    };

    const handleDeleteImage = (index) => {
        const updatedImagePreview = [...imagePreview];
        updatedImagePreview.splice(index, 1);
        setImagePreview(updatedImagePreview);
        const updatedImage = [...image];
        updatedImage.splice(index, 1);
        setImage(updatedImage);

        const fileInputImage = document.querySelector('input[type="file"][accept="image/*"]');
        if (fileInputImage) {
            fileInputImage.value = '';
        }
    };

    const handleDeleteVideo = (index) => {
        const updatedVideoPreview = [...videoPreview];
        updatedVideoPreview.splice(index, 1);
        setVideoPreview(updatedVideoPreview);
        const updatedVideo = [...video];
        updatedVideo.splice(index, 1);
        setVideo(updatedVideo);

        const fileInputVideo = document.querySelector('input[type="file"][accept="video/*"]');
        if (fileInputVideo) {
            fileInputVideo.value = '';
        }
    };

    const handleDeleteAudio = (index) => {
        const updatedAudioPreview = [...audioPreview];
        updatedAudioPreview.splice(index, 1);
        setAudioPreview(updatedAudioPreview);
        const updatedAudio = [...audio];
        updatedAudio.splice(index, 1);
        setAudio(updatedAudio);

        const fileInputAudio = document.querySelector('input[type="file"][accept="audio/*"]');
        if (fileInputAudio) {
            fileInputAudio.value = '';
        }
    };

    useEffect(() => {
        // This code will run when the 'open' prop changes
        if (open && editRecord) {
            if (editRecord.elements) {
                editRecord.elements.map(async (item) => {
                    if (item.value && item.value.question) {
                        // Loop through the "question" array
                        let imageArray = [];
                        let imagePreviewArray = [];
                        let videoArray = [];
                        let videoPreviewArray = [];
                        let audioArray = [];
                        let audioPreviewArray = [];
                        
                        await Promise.all(item.value.question.map(async (questionItem) => {
                            if (questionItem.type === "text") {
                                setInitalQuestionDescription(questionItem.question);
                                setQuestionDescription(questionItem.question);
                            }
                         
                            if (questionItem.type === "video") {
                                let videoUrl;
                                if (questionItem.question.includes("http://") || questionItem.question.includes("https://")) {
                                    videoUrl = questionItem.question; 
                                } else {
                                    videoUrl = global_var.CLOUD_ASSET_STORAGE_URL + '/' + questionItem.question; 
                                }
                            
                                let oldVideo = {
                                    "type": "video",
                                    "question": questionItem.question
                                };
                            
                                let questionVideo = {
                                    preview: videoUrl
                                };
                            
                                videoArray.push(oldVideo);
                                videoPreviewArray.push(questionVideo);
                            }
                            
                            if (questionItem.type === "image") {
                                const imageUrl = global_var.CLOUD_ASSET_STORAGE_URL + '/' + questionItem.question;
                                const response = await fetch(imageUrl);
                                const blob = await response.blob();
                                const previewUrl = URL.createObjectURL(blob);
                                let oldImage = {
                                    "type": "image",
                                    "question": questionItem.question
                                };
            
                                let questionImage = {
                                    preview: previewUrl
                                };
                                imageArray.push(oldImage);
                                imagePreviewArray.push(questionImage);
                            }
                            if (questionItem.type === "audio") {
                                // Store multiple audio items
                                const audioUrl = global_var.CLOUD_ASSET_STORAGE_URL + '/' + questionItem.question;
                                const response = await fetch(audioUrl);
                                const blob = await response.blob();
                                const previewUrl = URL.createObjectURL(blob);
                                let oldAudio = {
                                    "type": "audio",
                                    "question": questionItem.question
                                };
            
                                let questionAudio = {
                                    preview: previewUrl
                                };
                                audioArray.push(oldAudio);
                                audioPreviewArray.push(questionAudio);
                            }   
                        }));
            
                        setVideo(videoArray);
                        setVideoPreview(videoPreviewArray);
                        setImage(imageArray);
                        setImagePreview(imagePreviewArray);
                        setAudio(audioArray);
                        setAudioPreview(audioPreviewArray);
                    }
                });
            }
            if (editRecord && editRecord.assignTo) {
                editRecord.assignTo.forEach((assign) => {
                    if (assign.type === 'individual-students') {
                        setSelectedClassDivision([]);
                        setSelectedBatch([]);
                        setSelectedGroup([]);
                        setSelectedStudent(assign.individualStudents);
                        setAssignTo('IndividualStudents');
                    }
                    // const classDivisionObjects = [];
                    if (assign.type === 'class-division') {
                        setSelectedStudent([]);
                        setSelectedBatch([]);
                        setSelectedGroup([]);

                        const convertedArray = editRecord.assignTo.map((item) => ({
                            fkClassId: item.classId,
                            fkClassName: item.className,
                            fkDivisionId: item.divisionId,
                            fkDivisionName: item.divisionName,
                            streamId: item.streamId,
                            classStreamName: item.streamName
                          }));
                        setAssignTo('ClassDivisions');
                        setSelectedClassDivision(convertedArray);
                    }
                    if (assign.type === 'batches') {
                        setSelectedClassDivision([]);
                        setSelectedStudent([]);
                        setSelectedGroup([]);
                        setSelectedBatch(assign.batches);
                        setAssignTo('Batches');
                    }
                    if (assign.type === 'groups') {
                        setSelectedClassDivision([]);
                        setSelectedStudent([]);
                        setSelectedBatch([]);
                        setSelectedGroup(assign.groups);
                        setAssignTo('Groups');
                    }
                });
            }

            if (editRecord.fkResourceStudentLevelId) {
                setMoreOptionChecked(true);
                setSelectedLevel({
                    "_id": editRecord.fkResourceStudentLevelId,
                    "resourceStudentLevelName": editRecord.resourceStudentLevelName,
                    "resourceStudentLevelColor": editRecord.resourceStudentLevelColor
                })
            }


            form.setFieldsValue({
                questionTitle: editRecord.title,
                projectType: editRecord.projectType,
                maximumMark: editRecord.totalMark
            });

        }
        if (!open) {
                // Reset state variables when the modal is hidden
                setQuestionDescription(null);
                setMoreOptionChecked(false);
                setSelectedStudent([]);
                setSelectedLevel(null);
                setSelectedBatch([]);
                setSelectedGroup([]);
                setSelectedClassDivision([]);
                setImage([]);
                setAudio([]);
                setImagePreview([]);
                setAssignTo(null);
                setVideo([]);
                setVideoPreview([]);
                form.resetFields();
                setDueDateInitialValue(null);
        }
    }, [editRecord, open, form]);
    

    return (
        <Modal
            open={open}
            title="Edit Lab Assignment"
            onCancel={handleCancel}
            style={{ backgroundColor: '#ffffff' }}
            width={'50%'}
            footer={[
                <Button key="cancel" onClick={handleCancel} className='cancel-button'>
                    Cancel
                </Button>,
                <Button className='create-button'
                    style={{color:'#fff',borderColor: "#E96358"}}
                    key="ok"
                    loading={buttonLoader}
                    onClick={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                // Set loading to true when the button is clicked
                                onFinish(values);
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });
                    }}
                >
                    {buttonText}
                </Button>,
            ]}
        >
            <Form form={form} name="form_in_modal" onFinish={onFinish} layout="vertical">
                <Form.Item name="questionTitle" label="Question Title" rules={[{ required: true, message: 'Please enter the Question Title' }]}>
                    <Input />
                </Form.Item>

                <Form.Item name="questionDescription" label="Question Description" initialValue={questionDescription}>
                <TinyMCEEditor 
                    onEditorChange={handleEditorChange}
                    initialValue={intialQuestionDescription}
                />
                </Form.Item>
                <Form.Item name="projectType" label="Project Type" rules={[{ required: true, message: 'Please select a project type' }]}>
                    <Select defaultValue="default" style={{ width: '100%' }} disabled>
                        <Option value="default" disabled>
                            Select a project Type
                        </Option>
                        {Object.values(projectStacks)
                            .flatMap((items) =>
                            items
                                .map((item) => ({
                                ...item,
                                metaData: getIdeProjectTypeMetaData(item.projectStackName),
                                }))
                                .filter((item) => item.metaData.showLabQuestion)
                            )
                            .map((item) => (
                            <Option key={item.projectStackName} value={item.projectStackName}>
                                {item.metaData.projectStackDisplayName}
                            </Option>
                            ))}
                    </Select>
                </Form.Item>
                <Form.Item name="maximumMark" label="Maximum Marks">
                    {/* <Input type='number' /> */}
                    <InputNumber 
                        placeholder='Enter mark'style={{width:'100%' }}
                        min={0}
                        onKeyDown={(event) => {
                            if (!/[0-9]/.test(event.key) && event.key !== "Backspace") {
                                event.preventDefault(); // Blocks non-numeric input
                            }
                        }}
                    />
                </Form.Item>
                <Row className="mb-2">
                    <Form.Item name="image">
                        <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, 'image')} style={{ display: 'none' }} />
                        <Button className='mr-2 cancel-button'
                            icon={<FileImageOutlined style={{ verticalAlign: '-webkit-baseline-middle', marginBottom: '10px' }} />}
                            style={{ display: 'inline-block', verticalAlign: 'middle' }}
                            onClick={() => document.querySelector('input[type="file"][accept="image/*"]').click()}
                        >
                            Attach Images
                        </Button>
                        {/* Render image preview */}
                        
                        {imageLoading ? (
                            <Spin />
                        ) : (
                            imagePreview && (
                                <div>
                                    {imagePreview.map((preview, index) => (
                                        <div key={index} className='img-thumbnail-container' style={{ position: 'relative', display: 'inline-block' }}>
                                            <Image
                                                className='img-thumbnail'
                                                src={preview.preview}
                                                alt={`Preview ${index}`}
                                                style={{ width: '150px', height: '150px', objectFit: 'cover', margin: '10px' }}
                                            />
                                            <Popconfirm
                                                title="Are you sure to delete this image?"
                                                onConfirm={() => handleDeleteImage(index)}
                                                okText="Yes"
                                                cancelText="No"
                                                placement="bottomRight"
                                                overlayStyle={{ width: 'max-content' }} 
                                            >
                                                <DeleteOutlined style={{top:'15px', position: 'absolute',  right: '15px', cursor: 'pointer', color: 'red', fontSize:'15px' }} />
                                            </Popconfirm>
                                        </div>
                                    ))}
                                </div>
                            )
                        )}

                        

                    </Form.Item>
                    <Form.Item name="audio">
                        <input type="file" accept="audio/*" onChange={(e) => handleFileChange(e, 'audio')} style={{ display: 'none' }} />
                        <Button className='cancel-button'
                            icon={<AudioOutlined style={{ verticalAlign: '-webkit-baseline-middle', marginBottom: '10px' }} />}
                            style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: '8px' }}
                            onClick={() => document.querySelector('input[type="file"][accept="audio/*"]').click()}
                        >
                            Attach Audio
                        </Button>
                        {audioLoading ? (
                            <Spin />
                        ) : (
                            audioPreview && (
                                <div>
                                    {audioPreview.map((preview, index) => (
                                    <div key={index} style={{ position: 'relative', display: 'inline-block',top:'5px'}}>
                                        <audio controls style={{ marginLeft: '8px', marginTop: '2px' }}>
                                            <source src={preview.preview} type="audio/mpeg" />
                                            Your browser does not support the audio element.
                                        </audio>
                                        <Popconfirm
                                            title="Are you sure to delete this audio?"
                                            onConfirm={() => handleDeleteAudio(index)}
                                            okText="Yes"
                                            cancelText="No"
                                            placement="bottomRight"
                                            overlayStyle={{ width: 'max-content' }} 
                                        >
                                        <Tooltip title='Delete' >
                                            <DeleteOutlined style={{top:'20px', position: 'absolute', cursor: 'pointer', color: 'red', fontSize:'15px', right:'-25px' }} />
                                        </Tooltip>
                                        </Popconfirm>
                                    </div>
                                    ))}
                                </div>
                            )
                        )}
                    </Form.Item>

                    <Form.Item name="video">
                        <input type="file" accept="video/*" onChange={(e) => handleFileChange(e, 'video')} style={{ display: 'none' }} />
                        <Button className='cancel-button'
                            icon={<VideoCameraOutlined style={{ verticalAlign: '-webkit-baseline-middle', marginBottom: '10px' }} />}
                            style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: '8px' }}
                            onClick={() => document.querySelector('input[type="file"][accept="video/*"]').click()}
                        >
                            Attach Video
                        </Button>
                        {/* Render video preview */}
                        {videoLoading ? (
                            <Spin />
                        ) : (
                            videoPreview && (
                                <div>
                                     {videoPreview.map((preview, index) => (
                                        <div key={index} className='img-thumbnail-container' style={{ position: 'relative', display: 'inline-block',border:'1px solid #f4f4f4',top:'5px' }}>
                                         
                                            <video width="320" height="240" controls>
                                                <source src={preview.preview} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                            <Popconfirm
                                                title="Are you sure to delete this video?"
                                                onConfirm={() => handleDeleteVideo(index)}
                                                okText="Yes"
                                                cancelText="No"
                                                placement="bottomRight"
                                                overlayStyle={{ width: 'max-content' }} 
                                            >
                                            <Tooltip title='Delete' >
                                                <DeleteOutlined style={{top:'5px', position: 'absolute',  right: '5px', cursor: 'pointer', color: 'red', fontSize:'20px' }} />
                                            </Tooltip>
                                            </Popconfirm>
                                        </div>
                                    ))}
                                </div>
                            )
                        )}
                    </Form.Item>
                </Row>
                <Form.Item name="moreOption" className='mb-2' valuePropName="checked">
                    <Checkbox id="moreOptionCheckbox" className='mr-2' checked={moreOptionChecked} onChange={handleMoreOptionChange} />
                    <label htmlFor="moreOptionCheckbox">More option</label>
                </Form.Item>
                {moreOptionChecked && (
                    <Row className="mb-2">
                        {/* <Col span={11} style={{ marginRight: "8px" }}>
                            <Form.Item name="topic">
                                <Select defaultValue="default" style={{ width: '100%' }}>
                                    <Option value="default" disabled>Topic</Option>
                                    <Option value="Topic1">Topic1</Option>
                                    <Option value="Topic2">Topic2</Option>
                                    <Option value="Topic3">Topic3</Option>
                                </Select>
                            </Form.Item>
                        </Col> */}
                        <Col span={11}>
                            <Form.Item name="studentLevel">
                                <ResourceLevel onChange={handleResourceLevelChange} studentLevelName={selectedLevel ? selectedLevel.resourceStudentLevelName : null}></ResourceLevel>
                            </Form.Item>
                        </Col>
                    </Row>
                )}

                <label className='mb-2'>Assigned {assignTo}</label>

                {renderAssignToSection()}
                                
                <Form.Item name="dueDate" className='mb-2' valuePropName="checked">
                    <Checkbox id="dueDateCheckbox" className='mr-2' checked={dueDateChecked} onChange={handleDueDateChange} />
                    <label className='poppins-medium' style={{textDecoration:'underline',}} htmlFor="dueDateCheckbox">Choose a due date</label>
                </Form.Item>
                {dueDateChecked && (
                    <Row className="mb-2">
                        <Col span={11}>
                            <Form.Item name="dueDate" initialValue={dueDateInitialValue}>
                                <DatePicker
                                    onChange={handleDatePickerChange}
                                    format="YYYY-MM-DD"
                                    disabledDate={disabledDate}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                )}

            </Form>
        </Modal>
    );
};

export default EditAssignment;
